export class SharedServiceFunctions {
  listObject = {};
  dataObject = {};
}
